










































export default {
    name: 'nft-list',
};
